export function isValidCIE(value) {
  const regex = new RegExp("[a-zA-z0-9]{4,8}", "gm")
  const match = regex.exec(value)

  if (!match) return false

  return true
}
